"use client";
import { mergeProps } from "@base-ui-components/react/merge-props";
import { useRender } from "@base-ui-components/react/use-render";

interface ButtonProps extends useRender.ComponentProps<"button"> {}

function Button(props: ButtonProps) {
  // biome-ignore lint/a11y/useButtonType: <explanation>
  const { render = <button />, ...otherProps } = props;

  const element = useRender({
    render,
    props: mergeProps<"button">({}, otherProps),
  });

  return element;
}

export { Button };
